<div class="row">
  <div class="col-12">
    <h6 class="text-center routeEditGroupTitle mb-2">{{'ALARM_INDICATION_GROUP' | translate}}</h6>
  </div>
</div>

<div class="row">
  <div class="col-lg-4 col-md-12">
    <div class="card p-2">
      <h6 class="text-center devicesGroupTitle">{{'AVAILABLE_DEVICES' | translate}}</h6>

      <mat-list dense="true">

        @if (availableDevicesEmpty()) {
          <mat-list-item>
            <div mat-line>
              <span class="fa-light fa-check-double mr-1" style="vertical-align: middle"></span>
              <span class="devicesGroupTitle text-truncate">{{'ADD_ALL_DEVICES' | translate}}</span>
            </div>
            <mat-icon class="add-device-button" (click)="addAllDevices();">add_circle</mat-icon>
          </mat-list-item>
        }


        @for (group of deviceGroups; track group) {
          @if (availableDevicesInLocation(group.locationId)) {
            <mat-list-item>
              <div mat-line>
                @if (group.locationName) {
                  <span
                  class="fa-fw mr-2 fa-solid fa-house devicesGroupTitle"></span>
                }
                <span class="devicesGroupTitle text-truncate">{{group.locationName}}</span>
              </div>
              <mat-icon class="add-device-button" (click)="addDevicesByLocationId(group.locationId)">
              add_circle</mat-icon>
            </mat-list-item>
          }
          @for (device of group.deviceOptions; track device) {
            @if (!device.selected) {
              <mat-list-item>
                <div mat-line class="text-truncate">
                  <span [ngClass]="getDeviceIconClass(device.deviceType)" class="mr-1"
                  style="vertical-align: middle"></span>
                  @if (device.baseStationName) {
                    {{device.baseStationName}}
                  }
                  @if (!device.baseStationName) {
                    {{device.baseStationId}}
                  }
                  ({{getDeviceType(device.deviceType)}})
                </div>
                <mat-icon class="add-device-button" (click)="addDevice(device)">add_circle</mat-icon>
              </mat-list-item>
            }
          }
        }


      </mat-list>
    </div>
  </div>


  <!-- Selected devices -->

  <div class="col-lg-4 col-md-12">
    <div class="card p-2">
      <h6 class="text-center devicesGroupTitle">{{'SELECTED_DEVICES' | translate}}</h6>
      <mat-list dense="true">

        @if (selectedDevicesEmpty()) {
          <mat-list-item>
            <mat-icon class="remove-device-button" (click)="removeAllDevices();">remove_circle</mat-icon>
            <div mat-line>
              <span class="fa-light fa-check-double mr-1" style="vertical-align: middle"></span>
              <span class="devicesGroupTitle text-truncate">{{'REMOVE_ALL_DEVICES' | translate}}</span>
            </div>
          </mat-list-item>
        }

        @for (group of deviceGroups; track group) {
          @if (selectedDevicesInLocation(group.locationId)) {
            <mat-list-item>
              <div mat-line>
                @if (group.locationName) {
                  <span
                  class="fa-fw mr-2 fa-solid fa-house devicesGroupTitle"></span>
                }
                <span class="devicesGroupTitle text-truncate">{{group.locationName}}</span>
              </div>
              <mat-icon class="remove-device-button" (click)="removeDevicesByLocationId(group.locationId)">
              remove_circle</mat-icon>
            </mat-list-item>
          }
          @for (device of group.deviceOptions; track device) {
            <div [ngClass]="{'highlight-selection' : device.highlight}">
              @if (device.selected) {
                <mat-list-item>
                  <div
                    mat-line class="text-truncate selection-container"
                                  (click)="
                                    highlightDeviceOption(device);
                                    selectedDeviceForSettings = device"
                    >
                    <span
                      [ngClass]="getDeviceIconClass(device.deviceType)"
                      class="mr-1" style="vertical-align: middle">
                    </span>
                    <div
                      class="d-inline">
                      @if (device.baseStationName) {
                        {{device.baseStationName}}
                      }
                      @if (!device.baseStationName) {
                        {{device.baseStationId}}
                      }
                      <span> ({{getDeviceType(device.deviceType)}})</span>
                    </div>
                  </div>
                  <mat-icon class="remove-device-button" (click)="removeDevice(device)">remove_circle
                  </mat-icon>
                </mat-list-item>
              }
            </div>
          }
        }


      </mat-list>
    </div>
  </div>

  <div class="col-lg-4 col-md-12">
    <div class="card p-2 options-list">
      <h6 class="text-center devicesGroupTitle">{{'SETTINGS' | translate}}</h6>
      @if (!selectedDeviceByDeviceId($safeNavigationMigration(selectedDeviceForSettings?.baseStationId))) {
        <p class="text-center">
        {{'NO_DEVICES_SELECTED' | translate}} </p>
      }


      @if (selectedDeviceByDeviceId($safeNavigationMigration(selectedDeviceForSettings?.baseStationId))) {
        @if (selectedDeviceForSettings) {
          @if (selectedDeviceForSettings.baseStationName) {
            <p class="text-center">
            {{selectedDeviceForSettings.baseStationName}}</p>
          }
          @if (!selectedDeviceForSettings.baseStationName) {
            <p class="text-center">
            {{selectedDeviceForSettings?.baseStationId}}</p>
          }
        }
        <mat-slide-toggle [checked]="selectedDeviceForSettings.buzzerAndLed"
          class="ml-3 option"
          name="buzzerOption"
          #buzzerOption
          (change)="changeHighlightedBaseStationBuzzerOption(buzzerOption.checked)">
          @if (selectedDeviceForSettings.buzzerAndLed) {
            <span>{{'BUZZER_AND_LED' | translate}}</span>
          }
          @if (!selectedDeviceForSettings.buzzerAndLed) {
            <span>{{'BUZZER_ONLY' | translate}}</span>
          }
        </mat-slide-toggle>
        <div>
          <mat-form-field class="full-width mt-4 mb-2">
            <mat-label>{{'ALARM_TYPE' |translate}}</mat-label>
            <mat-select class="option" [value]="getHighlightedBaseStationAlarmOption()"
              (selectionChange)="changeHighlightedBaseStationAlarmOption(alarmOnHomeBase.selected, alarmOnRoamingBase.selected, alarmOnBoth.selected)">
              <mat-option #alarmOnHomeBase [value]="0">{{'ALARM_ON_HOMEBASE' | translate}}</mat-option>
              <mat-option #alarmOnRoamingBase [value]="1">{{'ALARM_ON_ROAMINGBASE' | translate}}
              </mat-option>
              <mat-option #alarmOnBoth [value]="2">{{'ALARM_ON_HOMEBASE' | translate}} &
              {{'ALARM_ON_ROAMINGBASE' | translate}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      }


    </div>

  </div>

</div>
